const decodeToken = (token) => {
  try {
    const clean = token.replace(/^"|"$/g, "");
    const base64 = clean.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
};

export default decodeToken;
